import { Modal } from "antd";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { Blocker } from "../hooks/useUnsavedChanges";

type Props = {
  blocker: Blocker;
};

export default function UnsavedChangesModal({ blocker }: Props) {

  return (
    <Modal
      open={blocker.state === "blocked"}
      title="Modifiche non salvate"
      okText="Esci senza salvare"
      cancelText="Resta nella pagina"
      onOk={() => blocker.proceed()}
      onCancel={() => blocker.reset()}
      okButtonProps={{ danger: true }}
      maskClosable={false}
      centered
    >
      <Alert variant="warning" className="d-flex align-items-center gap-2">
        <FontAwesomeIcon icon={faExclamationTriangle} />
        <span>Hai modifiche non salvate. Vuoi davvero uscire dalla pagina?</span>
      </Alert>
    </Modal>
  );
}
